export default __webpack_public_path__ + "static/media/it_3.8d95f504.mp3";